import React from "react";

import "./DesktopHome.css";

import { useDesktopHomeData } from "../../../hooks/useDesktopHomeData";

import DelegationCard from "../../delegations/DelegationCard/DelegationCard";
import ProjectsCard from "../../projects/projectCard/projectCard";
import HolidaysCard from "../../Holidays/HolidaysCard/HolidaysCard";
import ClockCard from "../ClockCard/ClockCard";
import CalendarComponent from "../../calendar/Calendar/Calendar";
import BarChart from "../BarChart/BarChart";

const DesktopHome = () => {
  const { isHR, realMembers, upcomingHolidays } = useDesktopHomeData();

  return (
    <div className="home-container bg-main">
      <div className="home-wrapper">
        
        <div className="section-top">
          <ClockCard />
          <div className="chart-container">
            <BarChart />
          </div>
        </div>

        <div className="section-bottom">
          
          <div className="left-column-stack">
            {isHR ? <DelegationCard members={realMembers} /> : <ProjectsCard />}
            <HolidaysCard holidays={upcomingHolidays} />
          </div>

          <div className="calendar-container">
            <CalendarComponent variant="compact" />
          </div>

        </div>

      </div>
    </div>
  );
};

export default DesktopHome;
